import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
const isEmptyPredicate = (value)=>{
    if (value == null) return true;
    if (typeof value === 'string') return value.length === 0;
    if (typeof value === 'boolean' || typeof value === 'number') return false;
    if (Array.isArray(value)) return value.every(isEmptyPredicate);
    if (typeof value === 'object') return Object.values(value).every(isEmptyPredicate);
    return false;
};
export const hasActiveFilter = (filter)=>Object.entries(filter).some((param)=>{
        let [key, value] = param;
        return key !== 'version' && !isEmptyPredicate(value);
    });
const pruneValue = (value)=>{
    if (Array.isArray(value)) return value.map(pruneValue).filter((entry)=>!isEmptyPredicate(entry));
    if (value != null && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map((param)=>{
            let [key, entry] = param;
            return [
                key,
                pruneValue(entry)
            ];
        }).filter((param)=>{
            let [, entry] = param;
            return !isEmptyPredicate(entry);
        }));
    }
    return value;
};
export const pruneEmptyPredicates = (filter)=>_object_spread_props(_object_spread({}, pruneValue(filter)), {
        version: filter.version
    });
export const isUserDrivenNarrowing = (param)=>{
    let { filter, lastQuery, filterEditedSinceLastSearch } = param;
    return filter != null && (filterEditedSinceLastSearch || lastQuery.length > 0) && hasActiveFilter(filter);
};
